/**
 * The CDP edge per build environment (`const.system.appEnv`), from the client's README.
 * Its own module so SEGMENT, whose CDP modes post to the same edges, can import it
 * without the CDP integration. Mirrored by `CDP_EDGES` in
 * api/src/modules/funnel-traffic/orders-check/coverage.ts.
 */
export const CDP_HOSTS: Readonly<Record<string, string>> = {
  production: 'https://events.cdp.in.nutrameg.com',
  staging: 'https://events.cdp.in.nutrameg.dev',
  development: 'http://localhost:4001',
}
